import { UserUrl } from "./AUrl";
import { BodylessApiResponse } from "../interfaces";
import axios, {AxiosResponse} from 'axios';


export async function dataAgree(token: string): Promise<BodylessApiResponse> {
    const url = new UserUrl().dataAgree;
    let response: AxiosResponse<any>;
    try {
        response = await axios.post<string | null>(url, {}, {
            headers: {
                'Content-Type': 'application/json',
                'token': token
            },
            // Resolve the promise for all HTTP status codes
            validateStatus: () => true
        });
    } catch (error) {
        return {
            status: 500,
            message: 'Network or other error occurred'
        };
    }

    if (response.status === 200) {
        return {
            status: response.status,
            message: "data agreed successfully"
        };
    } else {
        return {
            status: response.status,
            message: response.data as string
        };
    }
}
